import { styled } from "@mui/material"
import SearchBar, { SearchBarProps } from "components/SearchBar"

export const StyledSearchBar = styled(SearchBar)(({ theme }) => ({
  borderRadius: 40,
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  "& > .MuiOutlinedInput-notchedOutline": {
    borderColor: "#767676",
  },
}))

type SearchVideosBarProps = Exclude<SearchBarProps, "placeholder" | "variant">

const SearchVideosBar = (props: SearchVideosBarProps) => {
  return <StyledSearchBar {...props} placeholder="Search Videos" variant="outlined" />
}
export default SearchVideosBar
